module.exports = __webpack_public_path__ + "img/google-play-badge@2x.60bb45b5.png";